const ITEMS = [
  "Web Apps",
  "Mobile Development",
  "AI Chatbots",
  "Matlab & Mathematica",
  "PhD Proposals",
  "Math & Physics Tutoring",
];

const Strip = () => (
  <div className="flex items-center gap-10 pr-10">
    {ITEMS.map((item) => (
      <span key={item} className="flex items-center gap-10">
        <span>{item}</span>
        <span className="text-pink-500">&bull;</span>
      </span>
    ))}
  </div>
);

const Marquee = () => (
  <div className="py-4 border-b border-white/10 bg-[#09070e] overflow-hidden" data-testid="services-marquee">
    <div className="mq-track items-center font-poster text-xl tracking-wider uppercase text-slate-400">
      <Strip />
      <Strip />
    </div>
  </div>
);

export default Marquee;
